<template>
  <div>
    <div class="uc-userCenterTitle">
      <div class="left">
        <b>地址管理</b>
        <div class="tips">
          您已经创建
          <i class="uc-blue">{{ list.total_count }}</i> 个收货地址，最多可创建
          <i class="uc-blue">10</i> 个
        </div>
      </div>
      <a
        href="javascript:;"
        @click="dialogFormVisible = true"
        class="uc-btn blue-plain"
        >新增地址</a
      >
    </div>

    <section class="uc-userCenterTitleTab5">
      <div class="content-empty" v-if="list.total_count == 0">
        <div class="emptyimg-box"></div>
        <p>暂无相关内容</p>
      </div>
      <div
        class="item bg-white"
        v-for="(item, index) in list.items"
        :key="index"
      >
        <p><span class="txt">收货人：</span>{{ item.name }}</p>
        <p><span class="txt">联系电话：</span>{{ item.phone }}</p>
        <p>
          <span class="txt">地址：</span
          >{{ item.province + item.city + item.district + item.address }}
        </p>
        <p><span class="txt">邮编：</span>{{ item.post_code }}</p>
        <span class="uc-tag" v-show="item.is_default">默认地址</span>
        <div class="operate">
          <a
            href="javascript:;"
            @click="handleSetDefaultAddress(item.id)"
            class="btns"
            v-show="!item.is_default"
            >设为默认地址</a
          >
          <a
            href="javascript:;"
            @click="
              dialogFormVisible = true;
              getAddressDetails(item.id);
            "
            class="btns"
            >编辑</a
          ><a
            href="javascript:;"
            @click="handleDelAddress(item.id)"
            class="btns"
            >删除</a
          >
        </div>
      </div>
    </section>

    <el-pagination
      class="uc-prvNxt"
      background
      layout="prev, pager, next"
      hide-on-single-page
      :current-page="query.pageIndex"
      :page-size="query.pageSize"
      :total="list.total_count"
      @current-change="handleCurrentChange"
    >
    </el-pagination>

    <el-dialog
      title="收货地址"
      :visible.sync="dialogFormVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="handleCloseDialog"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-input v-model="form.id" type="hidden"></el-input>
        <el-form-item label="收货人" :label-width="formLabelWidth" prop="name">
          <el-input v-model.trim="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="所在地区"
          :label-width="formLabelWidth"
          prop="province"
        >
          <el-cascader
            placeholder="请选择省/市/区"
            :options="options"
            v-model.trim="selectedOptions"
            @change="handleChange"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item
          label="详细地址"
          :label-width="formLabelWidth"
          prop="address"
        >
          <el-input v-model.trim="form.address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="手机号码"
          :label-width="formLabelWidth"
          prop="phone"
        >
          <el-input
            v-model.trim="form.phone"
            autocomplete="off"
            maxlength="11"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮政编码" :label-width="formLabelWidth">
          <el-input
            v-model.trim="form.post_code"
            autocomplete="off"
            maxlength="6"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="默认地址" :label-width="formLabelWidth">
            <el-switch v-model="form.is_default"></el-switch>
          </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="handleCancel">取 消</el-button>
        <el-button type="primary" @click.native="handleSubmitSure"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { regionData, CodeToText, TextToCode } from 'element-china-area-data';

export default {
  name: 'PersonalAddress',
  data() {
    return {
      options: regionData,
      selectedOptions: [], // 省/市/区 选择
      dialogFormVisible: false,
      form: {
        id: 0,
        name: '',
        province: '',
        city: '',
        district: '',
        address: '',
        phone: '',
        post_code: '',
        is_default: false,
      },
      formLabelWidth: '120px',
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        province: [
          { required: true, message: '请选择所在区域', trigger: 'blur' },
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
        ],
        phone: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur',
          },
          {
            required: true,
            pattern: /^1[3-9]\d{9}$/,
            message: '请输入正确的手机号',
            trigger: 'blur',
          },
        ],
      },

      query: {
        pageIndex: 1,
        pageSize: 10,
      },
      list: [],
    };
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.getAddresses();
    },
    async getAddresses() {
      const response = await this.$api.integral.getAddresses(this.query);
      this.list = response.data.data;
    },
    async getAddressDetails(addrId) {
      const response = await this.$api.integral.getAddressDetails({
        id: addrId,
      });
      this.form = response.data.data;
      // 设置选中
      this.selectedOptions = [
        TextToCode[this.form.province].code,
        TextToCode[this.form.province][this.form.city].code,
        TextToCode[this.form.province][this.form.city][this.form.district].code,
      ];
    },
    // 切换选择
    handleChange(val) {
      this.form.province = CodeToText[val[0]];
      this.form.city = CodeToText[val[1]];
      this.form.district = CodeToText[val[2]];
    },
    // 提交数据
    handleSubmitSure() {
      const submitData = {
        id: this.form.id,
        name: this.form.name,
        province: this.form.province,
        city: this.form.city,
        district: this.form.district,
        address: this.form.address,
        phone: this.form.phone,
        post_code: this.form.post_code,
      };
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 请求后台
          // console.log(submitData);
          this.postAddress(submitData);
        }
      });
    },
    async postAddress(myaddress) {
      const response = await this.$api.integral.postAddress(myaddress);
      if (response.data.code === 200) {
        this.$message.success(response.data.message);

        this.dialogFormVisible = false;
        this.initData();

        // 清空表单
        this.$nextTick(() => {
          this.$refs.form.resetFields();
        });
      } else {
        this.$message.warning(response.data.message);
      }
    },
    handleDelAddress(addrId) {
      this.$confirm('确认删除该地址吗?', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.delAddress(addrId);
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
    },
    async delAddress(addrId) {
      const response = await this.$api.integral.delAddress({ id: addrId });
      if (response.data.code === 200) {
        this.initData();
        this.$message.success('删除成功!');
      } else {
        this.$message.warning(response.data.message);
      }
    },
    // 设置默认地址
    async handleSetDefaultAddress(addrId) {
      const response = await this.$api.integral.setDefaultAddress({
        id: addrId,
      });
      if (response.data.code === 200) {
        this.initData();
        this.$message.success('设置成功!');
      } else {
        this.$message.warning(response.data.messag);
      }
    },
    handleCancel() {
      this.dialogFormVisible = false;
      // 点击取消按钮的时候清除输入框中的内容 清除验证
      //  this.$nextTick获取了节点之后进行操作
      this.$nextTick(() => {
        // form对应你写的<el-form ref="form"></el-form>
        this.$refs.form.resetFields();
      });
    },
    handleCloseDialog() {
      this.$refs.form.resetFields();
    },
    // 翻页
    handleCurrentChange(val) {
      this.query.pageIndex = val;
      this.initData();
    },
  },
};
</script>
